import { useState } from "react"
import { saveForumMessage } from "../../api"
import { useAppState } from "../../hooks"
import { TUser } from "../../types"
import { ETextInputType } from "../../utils"
import { Input } from "../page"

type ForumFormProps = {
    forum: string,
    reloadMessage: any,
    user: TUser
}

export const ForumForm = ({ forum, reloadMessage, user }: ForumFormProps) => {

    const [message, setMessage] = useState('')
    const [messageError, setMessageError] = useState('')
    const { state } = useAppState()

    const addMessage = () => {
        setMessageError('')
        if (message.length < 1) {
            setMessageError('Zadejte text zprávy, kterou chcete odeslat.')
            return
        }
       
        saveForumMessage({
            forum: forum,
            message: {
                Author: user.Name,
                Message: message
            },
            token: state?.token
        }).then(res => {
            if (res.success) {
                setMessage('')
                reloadMessage()
            }
        })
    }

    return (
        <div className='forum_form'>
            <Input
                type={ETextInputType.TEXTAREA}
                label='Komentář:'
                value={message}
                errorMessage={messageError }
                setValue={e => setMessage(e.target.value)}
            />
            <button className='button' onClick={addMessage}> Odeslat</button>
        </div>
        )
}